import React from 'react'
import { useParams } from 'react-router'
import { useState, useEffect } from 'react';
import Footer from '../Layout/Footer';
import Navbar from '../Layout/Navbar'
import { data } from './ServiceData';


export default function Servicelist() {
  const { title } = useParams();
  const [fetchdata, setFetchData] = useState([])

  useEffect(() => {
    const finddata = data.find((items) => items.title.trim() === title.trim());
    setFetchData(finddata)
  },[title])



 
  return (
    <>
      <Navbar />
      <div className='w-full px-5 sm:px-0 sm:w-[80%] m-auto mt-20 py-10 '>
        <h1 className='text-3xl font-bold '> {fetchdata.title}</h1>
        <div className='mt-5 text-lg space-y-5'>


          <p >{fetchdata.firstparagraph} </p>
          <p >{fetchdata.secondparagraph} </p>
          <p >{fetchdata.thirdparagraph} </p>


        </div>

      </div>
      <Footer />
    </>
  )
}
